import { RampApi } from '../api/index.js';
import { RampType } from '../constants/index.js';
export class RampService {
    constructor(options) {
        this.fetchRequest = options.fetchRequest;
    }
    getRampInfo() {
        return this.fetchRequest.send({
            method: RampApi.getRampInfo.config.method,
            url: RampApi.getRampInfo.target,
            // headers: { 'Client-Type': this.clientType },
        });
    }
    getBuyCryptoData(params) {
        return this.fetchRequest.send({
            url: RampApi.getCrypto.target,
            method: RampApi.getCrypto.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getBuyFiatData(params) {
        return this.fetchRequest.send({
            url: RampApi.getFiat.target,
            method: RampApi.getFiat.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getBuyLimit(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampLimit.target,
            method: RampApi.getRampLimit.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getBuyExchange(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampExchange.target,
            method: RampApi.getRampExchange.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getBuyPrice(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampPrice.target,
            method: RampApi.getRampPrice.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getBuyDetail(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampDetail.target,
            method: RampApi.getRampDetail.config.method,
            params: Object.assign({ type: RampType.BUY }, params),
        });
    }
    getSellCryptoData(params) {
        return this.fetchRequest.send({
            url: RampApi.getCrypto.target,
            method: RampApi.getCrypto.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    getSellFiatData(params) {
        return this.fetchRequest.send({
            url: RampApi.getFiat.target,
            method: RampApi.getFiat.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    getSellLimit(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampLimit.target,
            method: RampApi.getRampLimit.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    getSellExchange(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampExchange.target,
            method: RampApi.getRampExchange.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    getSellPrice(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampPrice.target,
            method: RampApi.getRampPrice.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    getSellDetail(params) {
        return this.fetchRequest.send({
            url: RampApi.getRampDetail.target,
            method: RampApi.getRampDetail.config.method,
            params: Object.assign({ type: RampType.SELL }, params),
        });
    }
    sendSellTransaction(params) {
        return this.fetchRequest.send({
            url: RampApi.sendSellTransaction.target,
            method: RampApi.sendSellTransaction.config.method,
            params,
        });
    }
    getOrderNo(params) {
        return this.fetchRequest.send({
            url: RampApi.getOrderNo.target,
            method: RampApi.getOrderNo.config.method,
            params,
        });
    }
}
export class AlchemyPayRampService extends RampService {
    constructor(options) {
        super(options);
    }
    getAchPayToken(params) {
        return this.fetchRequest.send({
            url: RampApi.getAchPayToken.target,
            method: RampApi.getAchPayToken.config.method,
            params,
        });
    }
    getAchPaySignature(params) {
        return this.fetchRequest.send({
            url: RampApi.getAchPaySignature.target,
            method: RampApi.getAchPaySignature.config.method,
            params,
        });
    }
}
export * from '../signalr/index.js';
